module.exports = __webpack_public_path__ + "static/img/3.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/3.png
// module id = vv/5
// module chunks = 0